import React, { useEffect, useRef, useState } from 'react';
import Image from './Image'; // Import from your custom Image component

type Size = 'small' | 'large';

interface PolaroidProps {
  src: string;
  caption: string;
  background?: string;
  onClick?: () => void;
  isClickable?: boolean;
  size: Size;
}

const Polaroid: React.FC<PolaroidProps> = ({ src, caption, background, onClick, isClickable, size}) => {
  const imageRef = useRef<HTMLImageElement>(null);
  const [loading, setLoading] = useState(true);

  const SIZE_MAPPINGS: Record<Size, { width: number, height: number }> = {
    'small': {
      width: 110,
      height: 160,
    },
    'large': {
      width: 280,
      height: 320,
    }
  }

  const width = SIZE_MAPPINGS[size].width;
  const height = SIZE_MAPPINGS[size].height;

  useEffect(() => {
    const handleImageLoad = () => {
      if (imageRef.current) {
        // const imgWidth = imageRef.current?.naturalWidth || 0;
        // const imgHeight = imageRef.current?.naturalHeight || 0;
        // const scale = Math.min(width / imgWidth, height / imgHeight);
        // const scaledWidth = imgWidth * scale;
        // const scaledHeight = imgHeight * scale;

        // imageRef.current?.style.setProperty('width', `${scaledWidth}px`);
        // imageRef.current?.style.setProperty('height', `${scaledHeight}px`);

        imageRef.current?.style.setProperty('width', `${width - 20}px`);
        imageRef.current?.style.setProperty('height', `${height - 50}px`);
      }
    };

    if (imageRef.current) {
      handleImageLoad();
    }

    return () => {
      // Cleanup function (optional)
    };
  }, [src, size, width, height]);

  function onImageLoad() {
    setLoading(false);
  }

  return (
    <div 
      className={`relative flex flex-col gap-2 ${loading ? 'h-48' : 'overflow-hidden'} items-center text-center shadow-lg text-gray-900 border-gray-200 p-2 justify-between ${background} ${isClickable ? 'hover:bg-yellow-200' : ''} ${isClickable ? 'cursor-pointer' : ''}`}
      style={{ width }} 
      onClick={() => {isClickable && onClick && onClick()}}
    >
      <Image
        src={src} 
        alt={caption} 
        ref={imageRef} 
        onImageLoad={onImageLoad}
        className="object-contain"
      />

      <span className="flex grow align-center justify-center items-center text-xl" style={{fontFamily: "Dancing Script"}}>
        {caption}
      </span>
    </div>
  );
};

export default Polaroid;